import { Grid, Divider } from "@mui/material";
import ByzCard from "src/components/core-components/ByzCard";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import { useTranslate } from "src/locales/use-locales";

export default function PainAssessmentScaleInfoGrid() {
  const { t } = useTranslate();

  // 🔹 Pain Frequencies
  const painFrequenciesLeft = [
    t("pain-assessment-scale.pain-frequency.left.one-question"),
    t("pain-assessment-scale.pain-frequency.left.two-question"),
    t("pain-assessment-scale.pain-frequency.left.three-question"),
    t("pain-assessment-scale.pain-frequency.left.four-question"),
    t("pain-assessment-scale.pain-frequency.left.five-question"),
    t("pain-assessment-scale.pain-frequency.left.six-question"),
    t("pain-assessment-scale.pain-frequency.left.seven-question"),
    t("pain-assessment-scale.pain-frequency.left.eight-question"),
    t("pain-assessment-scale.pain-frequency.left.nine-question"),
    t("pain-assessment-scale.pain-frequency.left.ten-question"),
  ];

  const painFrequenciesRight = [
    t("pain-assessment-scale.pain-frequency.right.one-question"),
    t("pain-assessment-scale.pain-frequency.right.two-question"),
    t("pain-assessment-scale.pain-frequency.right.three-question"),
    t("pain-assessment-scale.pain-frequency.right.four-question"),
    t("pain-assessment-scale.pain-frequency.right.five-question"),
    t("pain-assessment-scale.pain-frequency.right.six-question"),
    t("pain-assessment-scale.pain-frequency.right.seven-question"),
    t("pain-assessment-scale.pain-frequency.right.eight-question"),
    t("pain-assessment-scale.pain-frequency.right.nine-question"),
    t("pain-assessment-scale.pain-frequency.right.ten-question"),
  ];

  // 🔹 Used Scales
  const usedScales = [
    t("pain-assessment-scale.used-scales.one-question"),
    t("pain-assessment-scale.used-scales.two-question"),
    t("pain-assessment-scale.used-scales.three-question"),
    t("pain-assessment-scale.used-scales.four-question"),
    t("pain-assessment-scale.used-scales.five-question"),
  ];

  // 🔹 Interventions
  const interventionsLeft = [
    t("pain-assessment-scale.interventions.left.one-question"),
    t("pain-assessment-scale.interventions.left.two-question"),
    t("pain-assessment-scale.interventions.left.three-question"),
    t("pain-assessment-scale.interventions.left.four-question"),
    t("pain-assessment-scale.interventions.left.five-question"),
    t("pain-assessment-scale.interventions.left.six-question"),
  ];

  const interventionsRight = [
    t("pain-assessment-scale.interventions.right.one-question"),
    t("pain-assessment-scale.interventions.right.two-question"),
    t("pain-assessment-scale.interventions.right.three-question"),
    t("pain-assessment-scale.interventions.right.four-question"),
    t("pain-assessment-scale.interventions.right.five-question"),
    t("pain-assessment-scale.interventions.right.six-question"),
    t("pain-assessment-scale.interventions.right.seven-question"),
    t("pain-assessment-scale.interventions.right.eight-question"),
    t("pain-assessment-scale.interventions.right.nine-question"),
  ];

  return (
    <Grid container spacing={2} alignItems="stretch">
      {/* Pain Frequency */}
      <Grid item xs={12} sm={6} md={4}>
        <ByzCard shadow sx={{ height: "100%", display: "flex", flexDirection: "column", borderRadius: 2 }}>
          <ByzMuiTypography fontSize={14} fontWeight={700}>
            {t("pain-assessment-scale.pain-frequency.title")}
          </ByzMuiTypography>
          <Divider sx={{ my: 1, borderColor: "#000", borderBottomWidth: "1px" }} />
          <Grid container spacing={2} sx={{ flexGrow: 1 }}>
            <Grid item xs={6}>
              <ByzMuiTypography component="div" sx={{ whiteSpace: "pre-line" }}>
                {painFrequenciesLeft.map((item, index) => `${index + 1}. ${item}\n`)}
              </ByzMuiTypography>
            </Grid>
            <Grid item xs={6}>
              <ByzMuiTypography component="div" sx={{ whiteSpace: "pre-line" }}>
                {painFrequenciesRight.map((item, index) => `${index + 1}. ${item}\n`)}
              </ByzMuiTypography>
            </Grid>
          </Grid>
        </ByzCard>
      </Grid>

      {/* Used Scales */}
      <Grid item xs={12} sm={6} md={4}>
        <ByzCard shadow sx={{ height: "100%", display: "flex", flexDirection: "column" ,borderRadius: 2 }}>
          <ByzMuiTypography fontSize={14} fontWeight={700}>
            {t("pain-assessment-scale.used-scales.title")}
          </ByzMuiTypography>
          <Divider sx={{ my: 1, borderColor: "#000", borderBottomWidth: "1px" }} />
          <ByzMuiTypography
            component="div"
            sx={{ whiteSpace: "pre-line", flexGrow: 1 }}
            lineHeight="30px"
          >
            {usedScales.map((item) => `* ${item}\n`)}
          </ByzMuiTypography>
        </ByzCard>
      </Grid>

      {/* Interventions */}
      <Grid item xs={12} sm={6} md={4}>
        <ByzCard shadow sx={{ height: "100%", display: "flex", flexDirection: "column", borderRadius: 2 }}>
          <ByzMuiTypography fontSize={14} fontWeight={700}>
            {t("pain-assessment-scale.interventions.title")}
          </ByzMuiTypography>
          <Divider sx={{ my: 1, borderColor: "#000", borderBottomWidth: "1px" }} />
          <ByzMuiTypography mb={1}>
            {t("pain-assessment-scale.interventions.one-line")}
          </ByzMuiTypography>
          <Grid container spacing={2} sx={{ flexGrow: 1 }}>
            <Grid item xs={6}>
              <ByzMuiTypography component="div" sx={{ whiteSpace: "pre-line" }}>
                {interventionsLeft.map((item) => `- ${item}\n`)}
              </ByzMuiTypography>
            </Grid>
            <Grid item xs={6}>
              <ByzMuiTypography component="div" sx={{ whiteSpace: "pre-line" }}>
                {interventionsRight.map((item) => `- ${item}\n`)}
              </ByzMuiTypography>
            </Grid>
          </Grid>
        </ByzCard>
      </Grid>
    </Grid>
  );
}
